module.exports = __webpack_public_path__ + "static/media/JCB.f7af5e03.svg";